<template>
  <div class="header">
    <div class="header-con">
      <div class="header-left cup" @click="toIndexFn">
        <img src="@/assets/images/new-001.png" alt="" />
        <p> 国际干燥科学与技术研究会
        </p>
      </div>
      <div class="header-right">
        <div class="header-top">
          <div class="language">
            <a href="https://www.iradstm.org/index/index.html#/" target="_blank"><span class="active">EN</span></a>
            /
            中文
          </div>
          <div class="join cup" @click="tojoin">Join IRADSTM</div>
        </div>
      </div>
    </div>
    <div>
      <div class="header-lists">
        <div class="header-list" :class="childrenShow == index + 1 ? 'active' : ''"
          @click.stop="changeBigFn(item, index)" v-for="(item, index) in list" :key="index">

          <p class="header-list-title">{{ item.nav_title }}</p>
          <div class="header-small-lists" v-show="childrenShow == index + 1 && childrenList.length != 0">
            <div @click.stop="changeSmallFn(itm, ind, item.nav_title)" class="header-small-list"
              v-for="(itm, ind) in childrenList" :key="ind">
              {{ itm.nav_title }}
            </div>
          </div>
        </div>
      </div>
      <p class="h5-btn" v-if="h5Show" @click="h5Show = false">收起</p>
      <p class="h5-btn" v-else @click="h5Show = true">展开</p>
      <div class="h5-lists" v-if="h5Show">
        <div class="h5-list" :class="childrenShow == index + 1 ? 'active' : ''" @click.stop="changeBigFn(item, index)"
          v-for="(item, index) in list" :key="index">
          <p class="h5-list-title">{{ item.nav_title }}</p>
          <div class="h5-small-lists" v-show="childrenShow == index + 1 && childrenList.length != 0">
            <div @click.stop="changeSmallFn(itm, ind, item.nav_title)" class="h5-small-list"
              v-for="(itm, ind) in childrenList" :key="ind">
              {{ itm.nav_title }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      h5Show: false,
      childrenShow: null,
      childrenList: [],
      list: [],
      urlList: [],
      current: 0,
    };
  },
  watch: {
    $route: "routerChange",
  },
  mounted() {
    this.routerChange();
    var lang = window.localStorage.getItem("language");
    this.$i18n.locale = lang;
    this.getNavFn();
  },
  methods: {
    getNavFn() {
      this.$http.nav_list().then((res) => {
        this.list = res.data;
        let list = res.data;
        this.urlList = [];
        list.forEach((item, index) => {
          let arr = [];
          if (item.url) {
            arr.push(item.url)
          }
          if (item.children.length > 0) {
            item.children.forEach((itm, ind) => {
              if (itm.model_id == 1) {
                arr.push(itm.url)
              } else {
                arr.push('/richTextEditor')
              }
            })
          }
          this.urlList.push(arr)
        })
      });
    },
    tojoin() {
      this.$router.push("/richTextEditor?nav_title=Membership&nav_small_title=Join%20IRADSTM&nav_id=81&nav_pid=72");
    },
    toIndexFn() {
      this.$router.push("/");
    },
    changeBigFn(item, index) {
      this.childrenList = item.children ? item.children : [];
      if (item.model_id == 1) {
        // 跳转链接
        if (item.children.length == 0) {
          if (this.$route.path != item.url) {
            this.$router.push(item.url);
          }
        }
      } else if (item.model_id == 2) {
        // 富文本
        this.$router
          .push({
            path: "richTextEditor",
            query: {
              nav_title: item.nav_title,
              nav_id: item.nav_id,
              nav_pid: item.nav_pid,
              nav_small_title: ""
            },
          })
          .catch((err) => {
            if (err.name !== "NavigationDuplicated") {
              throw err;
            }
          });
      }
      this.childrenShow = index + 1;
      this.current = index + 1;
    },
    changeSmallFn(item, index, nav_title) {
      if (item.model_id == 1) {
        // 跳转链接
        if (this.$route.path != item.url) {
          this.$router.push(item.url);
        }
      } else if (item.model_id == 2) {
        // 富文本
        if (this.$route.path == item.url) {
        }
        // 假设当前路由是 /search?keyword=vue
        this.$router
          .push({
            path: "richTextEditor",
            query: {
              nav_title: nav_title,
              nav_small_title: item.nav_title,
              nav_id: item.nav_id,
              nav_pid: item.nav_pid,
            },
          })
          .catch((err) => {
            if (err.name !== "NavigationDuplicated") {
              throw err;
            }
          });
      }
      this.childrenShow = null;
    },
    changeLang(con) {
      window.localStorage.setItem("language", con);
      this.$i18n.locale = con;
    },
    routerChange() {
      // for (let i = 0; i < this.urlList.length; i++) {
      //   if (this.urlList[i].includes(this.$route.path)) {
      //     this.current = i;
      //   }
      // }

      // if(this.$route.query.nav_small_title){
      //   if(["IRADSTM News",])
      // }

    },
  },
};
</script>

<style scoped lang="less">
.header {
  position: fixed;
  top: 0;
  width: 100vw;
  left: 0;
  background: #fff;
  height: 140px;
  z-index: 99;
  font-size: 18px;
  font-family: "Canaro, Arial, sans-serif";

  .header-con {
    width: 1200px;
    margin: 0 auto;
    align-items: center;
    height: 85px;
    padding-top: 15px;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
  }

  .header-left {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    color: #5b965a;
    font-weight: 500;

    p {
      font-size: 32px;
      text-shadow: 5px 5px 0 #dddddd, 7px 7px 0 #eeeeee;
      font-weight: 800;
    }

    img {
      height: 70px;
      width: auto;
      margin-right: 10px;
    }
  }

  .header-top {
    align-items: center;
    justify-content: end;
    display: flex;
    padding-top: 10px;
    box-sizing: border-box;
    height: 46px;

    .language {
      margin-right: 20px;

      a {
        color: #000;
      }

      .active {
        color: #5b965a;
        font-weight: 500;
      }
    }

    .header-search {
      font-family: "Canaro, Arial, sans-serif";
      margin-right: 30px;
      display: flex;
      font-size: 18px;
      align-items: center;

      i {
        font-size: 20px;
        margin-left: 4px;
      }
    }

    .shop-car {
      margin-right: 30px;
      position: relative;

      .shop-car-alert {
        position: absolute;
        display: none;
      }
    }

    .login-btn {
      border: 1px solid grey;
      color: grey;
      width: 100px;
      height: 36px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 30px;
    }

    .join {
      background-color: #f9b033;
      border: 1px solid #f9b033;
      width: 110px;
      height: 26px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 30px;
      padding: 0 5px 0 5px;
    }

    .language {
      cursor: pointer;
      color: #1f1f1f;
    }
  }

  .header-lists {
    display: flex;
    align-items: center;
    height: 45px;
    justify-content: center;
    background-image: url("../assets/images/navbg.png");
    background-size: 100% auto;
    background-repeat: repeat-x;
    background-position: top center;


    .header-list-title {
      margin: 0 18px;
      text-align: center;
      color: #fff;
      font-size: 18px;
      font-weight: 700;
      padding: 0 18px;
      white-space: nowrap;
      font-family: "Arial Narrow,sans-serif";
      box-sizing: border-box;
    }

    // .header-small-lists {
    //   display: none;
    // }

    // .header-list:hover .header-small-lists,
    // .header-list.active .header-small-lists {
    //   display: block;
    // }

    .header-list {
      position: relative;
      cursor: pointer;
    }

    .header-list::after {
      position: absolute;
      right: 0;
      top: 50%;
      content: "";
      display: inline-block;
      width: 3px;
      height: 16px;
      border-radius: 1.5px;
      transform: translateY(-50%);
      background-color: #f2e5da;
    }

    .header-list:nth-last-of-type(1)::after {
      content: none;
    }

    .header-list.active,
    .header-list:hover {
      position: relative;

      .header-list-title {
        color: #f9b033;
      }

      &::before {
        content: "";
        position: absolute;
        left: 20px;
        bottom: -10px;
        width: calc(100% - 40px);
        height: 6px;
        background: #f9b033;
        z-index: 99;
      }
    }
  }

  .header-list.active {
    .header-small-lists {
      display: block;
    }
  }

  .header-small-lists {
    position: absolute;
    top: 100%;
    background: #fff;
    left: 0;
    margin-top: 4px;
    display: block;
    z-index: 10;
    left: 20px;
    padding: 23px 20px;
    border-bottom: 6px solid #f9b033;
    white-space: nowrap;
    background-color: #fff;
    box-sizing: border-box;
    width: auto;
    box-shadow: 0 0 19px 0 rgba(0, 0, 0, 0.28);
  }

  .header-small-list {
    padding: 8px 12px;
    background-color: rgba(212, 235, 250, 0.25);
    color: #1f1f1fe2;
    font-family: "Canaro, Arial, sans-serif";
    cursor: pointer;
    margin-bottom: 5px;
    font-size: 13px;
    line-height: 1.8;
    font-weight: 400;
    white-space: nowrap;
    transition: 0.3s all;
  }

  .header-small-list.active,
  .header-small-list:hover {
    background: #d4ebfa;
  }

  .h5-lists,
  .h5-btn {
    display: none;
  }
}

@media screen and (max-width: 768px) {
  .header {
    .header-con {
      display: block;
      width: 100%;
    }

    .header-left {
      p {
        font-size: 18px;
      }

      img {
        width: 40px;
        height: auto;
      }
    }

    .header-lists {
      display: none;
      width: 100%;
      height: auto;
      padding: 3px 10px 5px;
      background-size: cover;
      flex-wrap: wrap;
      justify-content: start;

      .header-list-title {
        padding: 0 10px;
        margin: 0 4px;
        font-size: 14px;
      }

      .header-list.active,
      .header-list:hover {
        position: relative;

        .header-list-title {
          color: #f9b033;
        }

        &::before {
          content: "";
          position: absolute;
          left: 20px;
          bottom: 0px;
          width: calc(100% - 40px);
          height: 2px;
          background: #f9b033;
          z-index: 99;
        }
      }
    }

    .h5-btn {
      border-radius: 3px;
      border: 1px solid #ddd;
      width: 90px;
      font-size: 14px;
      justify-content: center;
      height: 30px;
      display: flex;
      position: fixed;
      top: 110px;
      right: 10px;
      z-index: 99;
      margin-left: 120px;
      align-items: center;
      color: #46260c;
      font-weight: 500;
      background-color: #ecc58666;
    }

    .h5-lists {
      position: fixed;
      right: 10px;
      top: 150px;
      display: block;
      background-color: #fff;
      z-index: 2;
      width: 160px;
      box-shadow: 2px 2px 8px #cecece88,
        -2px -2px 8px #cecece88,
        2px -2px 8px #cecece88,
        -2px 2px 8px #cecece88;
      border-radius: 4px;
      height: auto;
      padding: 3px 5px 5px;
      background-size: cover;
      flex-wrap: wrap;
      justify-content: start;

      .h5-list {
        position: relative;
        font-size: 14px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-bottom: 1px solid #ddd;
      }

      .h5-small-lists {
        position: absolute;
        right: 100%;
        top: 0;
        margin-right: 10px;
        width: calc(100vw - 200px);
        border-radius: 3px;
        border: 1px solid #eee;
        background-color: #fff;
        padding: 0 10px;
        box-sizing: border-box;
        box-shadow: 2px 2px 8px #cecece88,
          -2px -2px 8px #cecece88,
          2px -2px 8px #cecece88,
          -2px 2px 8px #cecece88;
      }

      .h5-small-list {
        color: #333;
        font-size: 14px;
        display: flex;
        align-items: center;
        justify-content: start;
        min-height: 30px;
        padding: 5px 10px;
        border-bottom: 1px solid #ddd;
      }
    }

    .h5-list.active,
    .h5-list:hover {
      position: relative;

      .h5-list-title {
        color: #f9b033;
      }

      &::before {
        content: "";
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/header.vue